import { cn } from "../../../utils/cn";
import { getItemTagLabels } from "../../../utils/help/itemExtras/itemExtras";
import { ItemType } from "../../../utils/types";
import { PChip, PChipSize } from "../PChip/PChip";
import styles from "./ItemTagChips.module.scss";

type ItemTagChipsProps = {
  item?: Pick<ItemType, "id" | "tags"> | null;
  /**
   * An unavailable item shows no tag at all — neither on the menu card nor on
   * the item page — so the "Unavailable" chip is never competing with a
   * "Best seller" one.
   */
  isOutOfStock?: boolean;
  size?: PChipSize;
  /** Applied to each chip, so callers can share the surrounding chip styling. */
  chipClassName?: string;
};

export const ItemTagChips = ({
  item,
  isOutOfStock = false,
  size = "xs",
  chipClassName,
}: ItemTagChipsProps) => {
  const labels = getItemTagLabels(item);

  if (!labels.length || isOutOfStock) {
    return null;
  }

  return (
    <div className={cn(styles.item_tags, styles[size])}>
      {labels.map((label, index) => (
        <PChip
          key={`${item?.id}-tag-${index}`}
          filled
          size={size}
          className={cn(styles.item_tag, chipClassName)}
          data-testid={
            index === 0
              ? `item-tag-${item?.id}`
              : `item-tag-${item?.id}-${index}`
          }
        >
          {label}
        </PChip>
      ))}
    </div>
  );
};
